var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1496_4028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1496_4028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 43.0499C8.76686 43.0499 7.7002 42.5999 6.8002 41.6999C5.9002 40.7999 5.4502 39.7332 5.4502 38.4999V9.4999C5.4502 8.23324 5.9002 7.1499 6.8002 6.2499C7.7002 5.3499 8.76686 4.8999 10.0002 4.8999H33.2002C33.8002 4.8999 34.3919 5.0249 34.9752 5.2749C35.5585 5.5249 36.0502 5.86657 36.4502 6.2999L42.2002 12.0499C42.6335 12.4499 42.9752 12.9416 43.2252 13.5249C43.4752 14.1082 43.6002 14.6999 43.6002 15.2999V38.4999C43.6002 39.7332 43.1502 40.7999 42.2502 41.6999C41.3502 42.5999 40.2669 43.0499 39.0002 43.0499H10.0002ZM39.0002 15.4499L33.0502 9.4999H10.0002V38.4999H39.0002V15.4499ZM24.5002 35.1999C25.9002 35.1999 27.1002 34.7082 28.1002 33.7249C29.1002 32.7416 29.6002 31.5332 29.6002 30.0999C29.6002 28.6999 29.1085 27.4999 28.1252 26.4999C27.1419 25.4999 25.9335 24.9999 24.5002 24.9999C23.1002 24.9999 21.9002 25.4916 20.9002 26.4749C19.9002 27.4582 19.4002 28.6666 19.4002 30.0999C19.4002 31.4999 19.8919 32.6999 20.8752 33.6999C21.8585 34.6999 23.0669 35.1999 24.5002 35.1999ZM14.9502 19.1499H28.1002C28.7669 19.1499 29.3169 18.9332 29.7502 18.4999C30.1835 18.0666 30.4002 17.5332 30.4002 16.8999V14.4499C30.4002 13.8166 30.1835 13.2832 29.7502 12.8499C29.3169 12.4166 28.7669 12.1999 28.1002 12.1999H14.9502C14.3169 12.1999 13.7835 12.4166 13.3502 12.8499C12.9169 13.2832 12.7002 13.8166 12.7002 14.4499V16.8999C12.7002 17.5332 12.9169 18.0666 13.3502 18.4999C13.7835 18.9332 14.3169 19.1499 14.9502 19.1499Z",
    fill: "url(#paint0_linear_1496_4028)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1496_4028",
    x1: 6.99682,
    y1: 4.89991,
    x2: 52.1358,
    y2: 7.73659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5334"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoColor);
export default __webpack_public_path__ + "static/media/IconoColor.3ddcc1da84ef1160dc87575948aeb732.svg";
export { ForwardRef as ReactComponent };